<template>
  <PostArticle
    v-if="post && Object.keys(post).length"
    link="PressRelease"
    :post-data="post"
    type="Press Releases"
  ></PostArticle>
</template>

<script setup lang="ts">
import { dataLoaded, useHandleError, useMetaData } from '@/composables/Common.js';
import PostArticle from '@/components/common/PostArticle.vue';
import { pressReleasePostQuery } from '@/queries/GetPressReleasePost';
import { ref } from 'vue';
import { useQuery } from 'villus';

const props = defineProps<{
  slug: string;
}>();

const { handleError } = useHandleError();
const { setMetaDescription, setMetaTitle } = useMetaData();

const post = ref({});

const { data } = useQuery({
  onData: data => {
    if (data !== undefined && data.pressRelease && Object.keys(data.pressRelease).length) {
      post.value = data.pressRelease;
      setMetaTitle(data.pressRelease.title);
      setMetaDescription(data.pressRelease.excerpt);
      dataLoaded();
    }

    if (!data || !data.pressRelease || Object.keys(data.pressRelease).length === 0) {
      handleError('PressReleasePost', props.slug);
    }
  },
  query: pressReleasePostQuery,
  variables: { slug: props.slug },
});
</script>

<script lang="ts">
export default {
  beforeRoute(params, villusClient) {
    return new Promise<void>((resolve, reject) => {
      villusClient
        .executeQuery({
          query: pressReleasePostQuery,
          variables: {
            slug: params.slug,
          },
        })
        .then(() => resolve())
        .catch((err) => reject(err));
    });
  },
};
</script>
